import React, { useEffect } from 'react'
import Navbar, { NavbarHidableItems } from '../../components/features/Navbar/Navbar'
import { Box } from '@chakra-ui/react'
import { LeftPanel } from '../../components/ui/Layout/LeftPanel'
import { RightPanel } from '../../components/ui/Layout/RightPanel'
import { ReportMenu } from '../ReportDetailPage/ReportMenu/ReportMenu'
import Layout from '../../components/ui/Layout/Layout'
import { ReportContext } from '../../contexts/ReportContext'
import rootStore from '../../store/RootStore'
import CommentsPanel from '../../components/features/Comments/CommentsPanel/CommentsPanel'
import OptionsTable from '../../components/features/Overview/OptionsTable'
import { observer } from 'mobx-react'
import ReactGA from 'react-ga4'

const pageTitle = 'All Options Overview'
const OverviewPage = () => {
  const {
    reportStore: {
      currentReport: { id: reportId, name: reportName },
    },
  } = rootStore

  /**
   * Google Analytics
   */
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: '/overview',
      title: `${reportId}: ${reportName}`,
    })
  }, [reportName, reportId])

  return (
    <Layout>
      <LeftPanel keepOpen>
        <ReportMenu />
      </LeftPanel>
      <ReportContext.Provider
        value={{
          refScrollContainer: null,
        }}>
        <Box
          background={'brand.lightestGray'}
          overflowY="auto"
          height="100vh">
          <Navbar
            title={pageTitle}
            hideItems={[
              NavbarHidableItems.SearchButton,
              NavbarHidableItems.ViewModeSwitch,
            ]}
          />
          <OptionsTable />
        </Box>
        <RightCommentPanel />
      </ReportContext.Provider>
    </Layout>
  )
}

const RightCommentPanel = observer(() => {
  const {
    commentStore: {
      setChartId,
      turnOffCommentsEnabled,
      turnOnCommentsEnabled,
      commentsDrawerVisible,
    },
  } = rootStore

  useEffect(() => {
    if (commentsDrawerVisible) {
      setChartId('overview-table')
      turnOnCommentsEnabled()
    } else {
      setChartId(undefined)
      turnOffCommentsEnabled()
    }
  }, [
    commentsDrawerVisible,
    setChartId,
    turnOffCommentsEnabled,
    turnOnCommentsEnabled,
  ])

  return (
    <RightPanel>
      <CommentsPanel />
    </RightPanel>
  )
})

OverviewPage.propTypes = {}

export default OverviewPage
